import type { ReactNode } from 'react';

import styles from './portal-dialog.module.css';

export function PortalDialogAction({ children }: { children: ReactNode }) {
  return <div className={styles['dialog-action']}>{children}</div>;
}

PortalDialogAction.Left = ({ children }: { children: ReactNode }) => (
  <div>{children}</div>
);

PortalDialogAction.Right = ({ children }: { children: ReactNode }) => (
  <div className={styles['dialog-action-right']}>{children}</div>
);
